export const ROLE = {
  USER: 1,
  SELLER: 2,
};
